import Vue from 'vue';
import Router from 'vue-router';
import Dossier from './views/Dossier.vue';
import Home from './views/Home.vue';
import PageNotFound from './views/PageNotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/dossier',
      redirect: '/'
    },
    {
      path: '/dossier/:id',
      name: 'dossier',
      component: Dossier
    },
    {
      path: '*',
      name: 'notFound',
      component: PageNotFound
    }
  ]
});
